import { query, types, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const getLocationDeliverectSalesDataQuery = (location_id: string, dateFrom: string, dateTo: string) => gql`
  ${query({
    locations_by_pk: params(
      { id: rawString(location_id) },
      {
        id: types.string,
        name: types.string,
        orders_deliverect: params(
          {
            where: {
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          [
            {
              id: types.string,
              order_number: types.string,
              order_display: types.string,
              location_id: types.string,
              organisation_id: types.string,
              account_id: types.string,
              customer_id: types.string,
              deliverect_status: types.string,
              deliverect_order_type: types.string,
              delivery_cost: types.number,
              service_charge: types.number,
              paid: types.boolean,
              courier_name: types.string,
              courier_phone: types.string,
              delivery_by: types.string,
              when_for: types.string,
              note: types.string,
              updated_at: types.string,
              created_at: types.string,
              deliverect_order_id: types.string,
              total: types.number,
              tax: types.number,
              discounts: types.custom<any[]>(),
            },
          ]
        ),
        orders_deliverect_aggregate: params(
          {
            where: {
              location_id: { _eq: rawString(location_id) },
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          {
            aggregate: {
              sum: {
                service_charge: types.number,
                tax: types.number,
                total: types.number,
                delivery_cost: types.number,
              },
              count: types.number,
            },
          }
        ),
      }
    ),
  })}
`;
